import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  MATCH: {
    SH0W_ALL: 'match.show_all',
    LIST_ALL: {
      REFRESH: 'MATCH.LIST_ALL.REFRESH',
      REFRESHING: 'MATCH.LIST_ALL.REFRESHING',
      REFRESHED: 'MATCH.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'MATCH.LIST_ALL.REFRESH_ERROR'
    },
    LIVE: {
      REFRESH: 'MATCH.LIVE.REFRESH',
      REFRESHING: 'MATCH.LIVE.REFRESHING',
      REFRESHED: 'MATCH.LIVE.REFRESHED',
      REFRESH_ERROR: 'MATCH.LIVE.REFRESH_ERROR'
    },
    PRONOSTICS: {
      REFRESH: 'MATCH.PRONOSTICS.REFRESH',
      REFRESHING: 'MATCH.PRONOSTICS.REFRESHING',
      REFRESHED: 'MATCH.PRONOSTICS.REFRESHED',
      REFRESH_ERROR: 'MATCH.PRONOSTICS.REFRESH_ERROR'
    },
    SHOW_MATCH_DETAIL: 'match.SHOW_MATCH_DETAIL',
    SHOW_COMPETITION_DETAIL: 'match.SHOW_COMPETITION_DETAIL'
  }
};

export const ENDPOINTS = {
  MATCH: {
    GET_LIVE:
      'https://api.kingrecharges.com/match/fetch/matches/live?group=lacasae',
    GET_LIST:
      'https://api.kingrecharges.com/match/fetch/matches/upcoming?group=lacasae&nbDaysInFuture=',
    GET_PRONOSTICS:
      'https://api.kingrecharges.com/match/fetch/matches/upcoming?group=lacasae&nbDaysInFuture=0'
  }
};

export const MATCH = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  }
};
